import validator from 'validator';

const validateEmail = (value: string) => {
    const email = value.replace(/\s/g, '').toLowerCase();
    if (validator.isEmpty(email)) {
        return {
            isValid: false,
            message: 'Veuillez remplir ce champ',
        };
    }
    if (!validator.isEmail(email)) {
        return {
            isValid: false,
            message: 'Veuillez entrer un mail valide',
        };
    } else
        return {
            isValid: true,
            message: '',
        };
};

export default validateEmail;
